<template>
  <section id="ratings">
    
    <div class="demo">
      <h5>Stars rating</h5>
      <fieldset class="star-rating">
        <legend class="sr-only">star ratings</legend>
        <input id="star-5" type="radio" name="rating" value="star-5">
        <label for="star-5">
          <span class="sr-only">5 stars</span>
          <i class="active gel-icon-3x gel-icon-star" aria-hidden="true" title="5 stars"></i>
        </label>
        <input id="star-4" type="radio" name="rating" value="star-4">
        <label for="star-4">
          <span class="sr-only">4 stars</span>
          <i class="active gel-icon-3x gel-icon-star" aria-hidden="true" title="4 stars"></i>
        </label>
        <input id="star-3" type="radio" name="rating" value="star-3" checked>
        <label for="star-3" >
          <span class="sr-only">3 stars</span>
          <i class="active gel-icon-3x gel-icon-star" aria-hidden="true" title="3 stars"></i>
        </label>
        <input id="star-2" type="radio" name="rating" value="star-2">
        <label for="star-2">
          <span class="sr-only">2 stars</span>
          <i class="active gel-icon-3x gel-icon-star" aria-hidden="true" title="2 stars"></i>
        </label>
        <input id="star-1" type="radio" name="rating" value="star-1">
        <label for="star-1">
          <span class="sr-only">1 star</span>
          <i class="active gel-icon-3x gel-icon-star" aria-hidden="true" title="1 star"></i>
        </label>
      </fieldset>
      <hr class="sg-hr"/>
      <h5>Smiley rating</h5>
      <div class="smileys" role="group" aria-label="rating">
        <div class="face face-red">
          <input type="radio" name="smiley" value="bad" class="bad" id="smiley-bad"/>
          <label for="smiley-bad"><span class="sr-only">Bad</span></label>
          <span>Bad</span>
        </div>
        <div class="face face-orange">
          <input type="radio" name="smiley" value="poor" class="poor" id="smiley-poor"/>
          <label for="smiley-poor"><span class="sr-only">Pool</span></label>
          <span>Poor</span>
        </div>
        <div class="face face-yellow">
          <input type="radio" name="smiley" value="fair" class="fair" id="smiley-fair" checked/>
          <label for="smiley-fair"><span class="sr-only">Fair</span></label>
          <span>Fair</span>
        </div>
        <div class="face face-lime">
          <input type="radio" name="smiley" value="good" class="good" id="smiley-good"/>
          <label for="smiley-good"><span class="sr-only">Good</span></label>
          <span>Good</span>
        </div>
        <div class="face face-green">
          <input type="radio" name="smiley" value="excellent" class="excellent" id="smiley-excellent"/>
          <label for="smiley-excellent"><span class="sr-only">Excellent</span></label>
          <span>Excellent</span>
        </div>
      </div>
    </div>
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/forms/ratings.md";
export default {
  name: "ratings",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.form.ratings.name);
    this.$emit("update-tagline", this.$root.yamlData.form.ratings.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
